import { Card } from '@pwskills/rachnaui';
import React from 'react';
import { companyImage } from '@/utils/common/env.constants';
import { IPlacementCompanies } from '@/interfaces/courseDescription';

type Props = {
  company: IPlacementCompanies;
};

const ToolsCard = ({ company }: Props) => {
  return (
    <Card
      className="p-[6px] bg-white shadow-light rounded-2xl shrink-0 !w-[286px] regular:!w-[330px] large:!w-[18.5%] !mx-3 regular:!mx-6"
      key={company._id}
    >
      <figure className="flex justify-center h-full items-center">
        <img
          src={`${companyImage}/company_logos/${company?.companyLogoFileName}`}
          alt={company?.name}
          className="w-[60%] regular:!w-[70%] aspect-[4/2] object-contain mx-auto"
        />
      </figure>
    </Card>
  );
};

export default ToolsCard;
